import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

// 스타일링된 컴포넌트를 생성합니다.
const TutorialArea = styled.div`
  #clip-01 {
    --x: 336px;
    --y: 1051px;
    --width: 1566px;
    --height: 258px;

    top: 0;
    left: 0;
    width: 1920px;
    height: 2000px;
  }

  #text-01 {
    top: 1338px;
    left: 709px;
  }

  #line-01 {
    top: 1311px;
    left: 637px;
  }
`;

const IssueHistory05 = () => {
  const elementRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, elementRef.current.offsetTop - 90); // GNB height
  }, []);

  return (
    <>
      <TutorialArea className='tutorial-area'>
        <div id="clip-01" className="clip-box">
          <div id="clip-01-hole" className="hole" />
          <div id="clip-01-border" ref={elementRef} className="border" />
        </div>

        <div className="text-box">
          <div id="text-01" className="text">
            You can check rate of issue type with a pie graph.
          </div>
        </div>

        <div className="line-box">
          <div id="line-01" className="line">
            <img src="/common/images/iss/tutorial/t_6173_line_01.png" alt='Line' />
          </div>
        </div>
      </TutorialArea>
    </>
  );
};

export default IssueHistory05;